export enum RequestResultType {
    Success,
    NoConnection,
    ServerError,
    InvalidCredentials,
    NotFound,
    BadRequest
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/request-result-type.ts